import React, { useEffect } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Landing from "./sections/landing";
import Approved from "../global-elements/approved/approved2";
import Terms from "./sections/terms";
import Declined from "../global-elements/declined";
import { useStoreState } from "easy-peasy";
import Error404 from "../../systempages/error404/Error404";
import DeclinedTemporal from "../global-elements/declinedTemporal";
import GrandBankPage from "../global-elements/grandbank/grandbankPage";
import { InactiveDetection } from "../../../services/inactiveDetection";
import ApprovedGrandBank from "../global-elements/approved/approved_grandbank";
import PDFTerms from "../global-elements/PDFTerms";
import { PRODUCT } from "../../../models/websiteTypesConstants";

function Layout() {
 
  const brandSettings = useStoreState((state) => state.siteSettingsModel.brandSettings);
  const termsStep = useStoreState(state => state.displayPrequalTerms);
  const resultStep = useStoreState(state => state.displayResult);

  InactiveDetection.setInactiveTitle(null);
  useEffect(() => {
    document.querySelector("title").textContent = `${brandSettings.ProductName} - Mastercard`;
    InactiveDetection.setTitle(`${brandSettings.ProductName} - Mastercard`);
  }, [brandSettings]);

  return (
    <Switch>
      <Route path="/getTerms/:productCode" component={() => <PDFTerms />} exact />
      {/* Landing page*/}
      <Route path="/" component={() => <Landing />} exact />
      {/* Terms page */}
      <Route path="/terms" component={() => (termsStep) ? <Terms /> : <Redirect to={"/"+window.location.search} />} exact />
      {/* ResultPages page */}
      <Route path="/approved" component={() => (termsStep) ? (brandSettings.ProductName === PRODUCT.Grand.bank ? <ApprovedGrandBank /> : <Approved />) : <Redirect to={"/"+window.location.search} />} exact />
      <Route path="/decision" component={() => (termsStep) ? <Declined /> : <Redirect to={"/"+window.location.search} />} exact />
      <Route path="/grandbank" component={() => (resultStep) ? <GrandBankPage /> : <Redirect to={"/"+window.location.search} />} exact/>
      <Route path="/pendinfo" component={() => (resultStep) ? <DeclinedTemporal /> : <Redirect to={"/"+window.location.search} />} exact />
      <Route  component={() => <Error404 />}  />
    </Switch>
  );
}

export default Layout;
